import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import 'vuetify/dist/vuetify.css'
// import 'vuetify/src/stylus/main.styl'

import 'material-design-icons-iconfont'
import '@mdi/font/css/materialdesignicons.css'
//
import '../themes/_default.scss'
import '../themes/_theme.scss'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: true,
    themes: {
      light: {},
      dark: {
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        primary: '#8e9090',
        secondary: '#616161',
        success: '#4CAF50',
        warning: '#FB8C00',
        contact: '#5cbbf6'
      }
    }
  }
})
